module.exports = __webpack_public_path__ + "img/zjzt-detail.c63bf6b6.png";